export default {

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "¿Quiénes",
      "646u995lv9g0": "somos?",
      "646u9d5lv9g0": "Danghuan es una empresa cuyo negocio principal se centra en el reciclaje, la disposición y la venta de productos digitales 3C como móviles, tabletas, laptops y relojes. Nuestra empresa está dedicada a acelerar la eficiencia del reciclaje de productos electrónicos y promover el desarrollo saludable del mercado de segunda mano. Actualmente, hemos establecido alianzas estratégicas oficiales con OPPO, Vivo, OnePlus, Realme y otros. Nuestro negocio internacional se ha expandido a India, Tailandia, Vietnam, Camboya y ahora Europa.",
      "646u995dv9g0": "Nuestra presencia global nos ha posicionado como un socio estratégico para operadores de telefonía móvil, fabricantes y mayoristas con alcance tanto continental como transcontinental.",
      "646u99slv9g0": "Colaboramos con los principales fabricantes y mantenemos un inventario diverso que incluye dispositivos de gama baja, media y alta. Esto nos permite ofrecer soluciones personalizadas y precios competitivos para satisfacer las necesidades de nuestros clientes."
    },
    "business": {
      "646v04syvpk0": "¿Está interesado en comprar nuestros lotes?",
      "646v04syxs80": "En Danghuan, ofrecemos una amplia selección de teléfonos móviles, tabletas y relojes inteligentes, disponibles en diversos niveles de clasificación para satisfacer las variadas necesidades empresariales.",
      "646v04syy6g0": "Contacte a nuestro Gerente de Ventas y Compras:",
      "646v04syya80": "Quiero Comprar",
      "646v04syydg0": "Escribir tu nombre",
      "646v04syyh40": "Escribir tu número de teléfono",
      "646v04syyyw0": "Escribir tu Email",
      "646v0gsyz1s0": "País:",
      "646v04syz1s0": "Por favor, elige una opción. ",
      "646v04syz4o0": "He leído y acepto la ",
      "646v04syzkc0": "Política de Privacidad",
      "646v04syzok0": "Contact us",
      "646v04syzvo0": "Por favor, introduzca su número de teléfono",
      "646v04syzys0": "Por favor, introduzca su correo electrónico",
      "646v04sz01o0": "Por favor, introduzca un correo electrónico válido",
      "646v04sz04g0": "Por favor, introduzca su nombre",
      "646v04sz0740": "Marque la casilla para aceptar la política de privacidad.",
      "646v04sz0a00": "Envío exitoso",
      "646v04sz0cw0": "Envío fallido",
      "title1": "Clasificación Transparente de Móviles",
      "text1-1": "Para facilitar sus decisiones de compra, le invitamos a consultar nuestro documento detallado de Clasificación. En él se describen los estándares estéticos y funcionales de cada categoría, ayudándole a elegir con confianza según sus expectativas.",
      "title2": "Atención al cliente excepcional.",
      "text2-1": "Reconocemos las necesidades únicas de cada cliente, por lo que nuestro equipo de profesionales de ventas multilingües está dedicado a ofrecer una asistencia personalizada y experta.",
      "title3": "Compromiso con la Tecnología Sostenible",
      "text3-1": "Estamos comprometidos con el avance del acceso global a soluciones tecnológicas sostenibles, asegurando que nuestros procesos generen valor para todas las partes interesadas.",
      "text3-2": "Para más consultas o para realizar un pedido, por favor contáctenos. Nuestro equipo está listo para asistirle con profesionalismo y dedicación."
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "¿Quiénes somos?",
      "646ntjwmn580": "Empresas",
      "646nt7hwils0": "Contáctanos",
      "646nt7hwipg0": "Comprar",
      "646nt7hwis00": "Vender"
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Recibe tu pago rapidamente en 4 pasos",
      "s1": "Primer paso",
      "s1t": "Empaqueta bien tu dispositivo para que llegue en perfecto estado.",
      "s2": "Segundo paso",
      "s2t": "Entrega tu paquete en el punto de entrega más cercano.",
      "s3": "Tercer paso",
      "s3t": "Empaqueta tu dispositivo con cuidado para que llegue seguro y sin daños.",
      "s4": "Cuarto paso",
      "s4t": "Recibe el pago en tu cuenta tras la verificación."
    },
    "section3": {
      "646tmse2fbo0": "Móviles",
      "646tmse2mv00": "Estén atentos",
      "section3-text2": 'Próximamente',
      "section3-text4": 'Próximamente',
      "section3-text5": 'Próximamente',
      "title": "¡Valora tu dispositivo en segundos!",
      "t1": "Selecciona el tipo de dispositivo y obtén una cotización al momento.",
      "t2": "Fácil, rápido y sin complicaciones: ¡dale una nueva vida a tu antiguo equipo!",
    },
    "section6": {
      "646txzpazuc0": "Acerca de Danghuan",
      "666txzpazuc0": "Somos una empresa especializada en el reciclaje y la reutilización de smartphones, tabletas y otros dispositivos digitales.<br> Ofrecemos un servicio rápido, seguro y eficiente, para que cada cliente pueda reciclar sus dispositivos de forma sencilla.",
      "646txzpb0rk0": "Detalles",
      "646txzpb0xc0": "Marcas líderes reciclables"
    },
    "section7": {
      "646ns2k5f7k0": "Siempre a tu disposición.",
      "646ns2k5gmw0": "Horario de atención: lunes a viernes, 9:00–18:00 (hora de Madrid)",
      "646ns2k5gs40": "Nombre",
      "646ns2k5gx40": "Teléfono",
      "646ns2k5img0": "Email",
      "646ns2k5isw0": "¿En qué podemos ayudarte?",
      "646ns2k5iws0": "Contáctanos",
      "646ns2k5j140": "Por favor, introduzca su número de teléfono",
      "646ns2k5j4g0": "Escribir tu Email",
      "646ds2k5j4g0": "Email",
      "646ns2k5j6c0": "Por favor, introduzca un correo electrónico válido",
      "646ns2k5j8g0": "Contáctanos",
      "646ns2k5jak0": "C.I.F.",
      "646ns2k5jck0": "Dirección",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1, Loft 2, 28045, Madrid",
      "646ns2k5jgc0": "Por favor, introduzca su nombre",
      "646ns2k5ji40": "Marque la casilla para aceptar la política de privacidad.",
      "646ns2k5jk00": "Mensaje enviado",
      "646ns2k5jm80": "Envío fallido",
      "646ny1rgz3c0": "He leído y acepto la ",
      "646ny1rh2k40": "Política de Privacidad"
    },
    "successMain": {
      "647qmd42l1s0": "✅ ¡Pedido recibido correctamente!",
      "647qmd42mss0": `📩 Revisa tu correo <b> (no-reply@danghuan.eu) </b> para las instrucciones de envío.`,
      "647qmd42dv6f": "Si no lo encuentras, contacta: <b> support@danghuan.eu </b>",
      "647qmd42xsv3": "🎁 Consigue un <b>12% de descuento extra</b> por participar en el programa de canje. ",
      "647qmd42gc5e": "🎁 <b>12% de descuento extra</b> por canje.",
      "647qmd42fx9q": "💰 Úsalo en <b style='color: #405fff'>vivoonlinestore.com</b> al finalizar tu compra.",  
      "647qmd42mz80": "Valor estimado",
      "647qmd42yeo0": "Sugerencias antes del envío",
      "orderTime": "Fecha de pedido",
      "text1": "Envío gratuito",
      "text2": "Recibirás la guía de envío por email. Por favor, revísala con atención.",
      "text3": "Copia de seguridad de datos",
      "text4": "Haz una copia de seguridad y elimina todos los datos del dispositivo.",
      "text5": "Cargar",
      "text6": "Carga tu móvil al menos al 1% antes de enviarlo.",
      "promotionCode": "🔑 <b>Código:</b> ",
      "copy": "Copiar código",
      "downloadDec": "Por favor, descarga la declaración de integridad.",
      "647qmd42rd5g": "📅 Válido hasta el <b>31/12/2025.</b>",
      "647qmd42f3d2": "📅 Válido hasta el <b>31/12/2025.</b>",
      "647qmd42d5a6": "💥 ¡Consigue un descuento exclusivo por participar en el programa de canje!",
      "647qmd42d1st": "🔹 Para <b>vivo X300 PRO Bundle</b>",   // 新增
      // "647qmd426eg9": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>250 €</b> de descuento directo.", // 新增 
      "647qmd426eg9": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén un <b>12%</b> de descuento extra.", 
      "647qmd42s6f2": "📅 Válido hasta el <b>30/06/2026.</b>", // 新增
      "647qmd42d3e2": "🔹 Para <b>vivo X300</b>", 
      "647qmd42ey6q": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>100 €</b> de descuento directo.",
      "647qmd42fd26": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>50 €</b> de descuento directo.",
      "647qmd423q6e": "🔹 Para otros modelos",
      "647qmd42uq3c": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén un <b>12%</b> de descuento extra.",
      "647qmd4eq3f6": "🔹 Para <b>vivo X300 PRO</b>",
      "647qmd4ee3qt": "⚠️ Los códigos de cupón no son acumulables.",
    },
    "tradeInProcess": {
      "649f8aefats0": "Tiempo Agotado",
      "649f8aefc1c0": "Reciclaje fallido",
      "649f8aefc9c0": "Vender ahora",
      "TradeIn": "Proceso de Trade-in",
      "logistic": 'Descargar etiqueta de envío',
      "start": "Pedido Creado",
      "success": "Su pedido ha sido realizado con éxito en nuestro sitio web.",
      "qc": "Inspección",
      "business": "Vamos a completar el proceso de inspección en 1-2 días laborales",
      "completed": "Completado",
      "successfully": "Tu trade-in proceso ha realizado con éxito",
      "orderInfor": "Información de pedido",
      "orderID": "Número de orden de reciclaje",
      "orderNum": "New device order number",
      "createTime": "Fecha de creación",
      "brand": "Marca seleccionada",
      "model": "Modelo seleccionada",
      "price": "Valor del dispositivo",
      "bonus": "Bono",
      "total": "Precio total",
      "logisticInfo": "Información logística",
      "available": "No logistics information available",
      "logisticNum": "Logistics number",
      "failRey": "Lamentamos que tu participación en el proceso trade-in no haya sido completada con éxito. Si tienes un plan de reciclaje para otros productos electrónicos, puedes hacer clic en el botón para obtener una cotización rápida",
      "userRes": "El usuario ya ha rechazado la oferta",
      "successPrice": "The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.",
      "sure": "Aceptar",
      "Reject": "Rechazar",
      "congratulation": "Congratulations QC No difference.",
      "finPirce": "Precio final",
      "copySuccess": "Copiado exitosamente",
      "copyfail": "Copia fallida",
      "sureSuccess": "El proceso de selección de productos",
      "submitError": "Envío fallido",
      "detectionResult": "Resultado de la detección",
      "Collected": "Recogido",
      "inTransit": "En Transito",
      "656g0lj3sav6": "Procesos",
      "656g0lj3cd5a": "Complete correctamente su información personal y realice su pedido",
      "656g0lj3dr9a": "La inspección para su móvil será completado dentro de 48 horas a su llegado a nuestro centro",
      "656g0lj3epal": "Una vez completada la inspección, nos pondremos en contacto con usted con una oferta final por correo electrónico",
      "656g0lj3pda2": "Ha elegido",
      "656g0lj3ed3d": "Inspección",
      "656g0lj3esf3": "Copiar",
      '656g0lj3sf6e': 'Los bonos promocionales son ofrecidos y gestionados por las marcas asociadas. Se abonarán por separado y no forman parte de la valoración del dispositivo antiguo.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Negarse a reciclar",
      "64a9shqq3k00": "Confirmas tu negativa a reciclar",
      "64a9shqq3r00": "Cancelación exitosa",
      "64a9shqq3ws0": "Cancelación fallida",
      "sureCancel": "Confirmar cancelación"
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Redes Sociales",
      "646d71qugz40": "Pago seguro con:",
      "646u51qugz40": "Logísticas",
      "646u5dqui780": "Política de Privacidad",
      "646uddqui780": "Términos y Condiciones",
      "646u51qui780": "Preguntas frequentes"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Cotización gratis"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Busca tu modelo (ej. vivo X100)",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Lo siento, este modelo no existe",
      "confirm": 'Confirmar',
      "cancle": "Cancelar",
      "dialogText": '¿Estás seguro de eliminar todo el \n historial?'
    }
  },
  "PCProduct": {
    "empty": "Lo siento, este modelo no existe"
  },
  "PCBrandTab": {
    "index": "Marca"
  },
  "PCCategoryTab": {
    "index": "Categoría"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Pedido online",
      "646xagqwkuw0": "Envío gratuito",
      "646xagqwmao0": "Inspección",
      "646xagqwmlc0": "Pago rápido"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Inicio"
    }
  },
  "router": {
    "selectModel": "Modelos",
    "selectProperty": 'Datos del dispositivo',
    "price": "Precio estimado",
    "priceOrder": 'Datos del pedido',
    "orderSuccess": "Confirmación de pedido"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Seleccionar otro modelo",
      "646ymq6ot0k0": "Recordatorio",
      "646ymq6pd100": "Antes de enviar tu dispositivo, asegúrate de cerrar sesión en iCloud o en tu cuenta de Google, y de desactivar cualquier tipo de bloqueo de pantalla.",
      "646ymq6pekw0": ""
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Seleccionar el estado del dispositivo",
      "647h1f4yr6c0": "Valor estimado",
      "647h1f4yso80": "Bonus extra estimado",
      "text1": "Envío gratuito",
      "text2": "Ofrecemos un servicio gratuito de logística y envío",
      "text3": "Depósito inmediato",
      "text4": "Depósito inmediato. Realizaremos el pago dentro de 1 a 2 días hábiles una vez hayamos recibido su dispositivo usado.",
      "64tve23zt0g0": "Recogida gratuita y etiqueta de envío incluida.",
      "64tve23zup00": " ¿No estás satisfecho? Te devolvemos el dispositivo sin coste.",
      "64tve23zuy40": "Borrado seguro de datos personales.",
      "64tve23zv7g0": "Pago procesado en 3 días hábiles tras la inspección del dispositivo.",
      "64tve23zvbg0": "Elige el método de entrega",
      "64tve23zvf80": "Tienes hasta 10 días para enviar tu dispositivo.",
      "64tve23zvjc0": "Recibe una etiqueta por email y para envíalo sin coste.",
      "64tve23zvms0": "Imprime la etiqueta y pégala en un sobre rígido y acolchado.",
      "64tve23zvqg0": "Importante:",
      "64tve23zvyo0": "Por razones de seguridad, <b> no envíes el dispositivo si sospechas que la batería está hinchada o dañada. </b>",
      "64tve23zwak0": "Los accesorios y el embalaje enviados no serán devueltos.",
      "64tve23zwgs0": "Siguientes pasos", 
      "64tve23zwm80": "Rellena tus datos personales y de contacto para generar la orden de recogida.",
      "64tve23zwt00": "Firma la <b> declaración de integridad </b> antes de enviar el paquete.",
      "64tve23z9d6f": "Prepara tu dispositivo para el envío.",
      "64tve23zwwk0": "Tu dispositivo será revisado a su llegada. Si la información proporcionada no coincide con el estado real, te enviaremos una nueva oferta. Podrás aceptarla o solicitar la devolución del dispositivo sin ningún coste.",
     
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话。--",
      "646ynp3uehw0": "Introduce el número de IMEI",
      "646ynp3uem40": "Marca *#06# en el teclado para consultar el IMEI"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Obtener valoración"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "El valor de los móviles y productos electrónicos disminuye un 6 % cada semana. ¡Véndelo cuanto antes!",
      "647hqss760c0": "He leído y acepto la",
      "647hqss764w0": "Política de Privacidad",
      "647hqss76ac0": "Términos y condiciones",
      "647hqss76dg0": "Continuar",
      "647hqss76gw0": "Nuestra oferta",
      "text1": 'La estimación más alta',
      "text2": "La estimación más alta",
      "text3": "Subsidio",
      "dialogTitle": "AVISO",
      "dialogText": "Haga clic en el botón CONFIRMAR y revise su correo electrónico para seguir el siguiente paso",
      "dialogBtn": "CONFIRMAR",
      "settleaccountBtn": "Confirmar pedido"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Información personal y bancaria",
      "647kboa06ys0": "Nombre",
      "647kboa078s0": "Teléfono",
      "647kboa07d00": "Dirección de domicilio",
      "647kboa07jk0": "País",
      "647kboa07p80": "Seleccione",
      "647kboa05s1d": "Rellenar",
      "647kboa08b40": "Código postal",
      "647kboa08h00": "Ciudad",
      "647kboa08zc0": "Dirección domiciliaria",
      "647kboa09440": "Información bancaria",
      "647kboa096w0": "Verificación de correo electrónico",
      "647kboa09ao0": "Email",
      "647kboa09dk0": "Código de verificación",
      "647kboa09u40": "rellenar",
      "647kboa09z80": "enviar",
      "647kboa0ak00": "Correo electrónico incorrecto",
      "647kboa0aog0": "Enviado con éxito",
      "send": "Enviado",
      "submit": "Enviar",
      "error": "Error de código de verificación",
      "64jjt96fg400": "Por favor, introduzca el código de verificación",
      "64jjt96fki00": "Por favor obtenga el código de verificación",
      "declaration": "Declaración de integridad",
      "download": "Descargar",
      "647kboa0idc0": "N.º de identificación personal",
      "647kboa0idc1": "(El número de identidad oficial emitido por tu país, \n utilizado para la identificación en trámites legales, \n fiscales o administrativos. Puede ser tu DNI, NIE, \n Codice Fiscale, Personalausweisnummer, CNP, \n u otro documento nacional equivalente, \n según tu país de residencia.)",
      "647kboa0idc2": "(El número de identidad oficial emitido por tu país, \n utilizado para la identificación en trámites legales, \n fiscales o administrativos. Puede ser tu DNI, NIE, \n Codice Fiscale, Personalausweisnummer, CNP, \n u otro documento nacional equivalente, \n según tu país de residencia.)",
      "idError": "Número de identificación no válido",
      "ibanTip": "Se usa para recibir el importe \n correspondiente al dispositivo antiguo.",
      "addreddPlaceholder": "Este campo admite hasta 105 caracteres"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Finalizar compra en vivo",
      "notRecyclable": "Este tipo de dispositivo no es reciclable.",
      "IKnow": "Veo",
      "tips": "pista"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "649fhwp9zbo0": "Subir foto de embalaje",
      "649fhwpa1900": "Descargar etiqueta de envío",
      "649fhwpa1l00": "Descargar etiqueta de envío",
      "649fhwpa1tc0": "Depositado",
      "649fhwpa2100": "Foto de embalaje",
      "649fhwpa2880": "Etiqueta de envío ",
      "649fhwpa2h80": "Consejo",
      "649fhwpa2qk0": "Envuelve el móvil con al menos 6 cm de material acolchado (papel burbuja, kraft, etc.) y colócalo en una caja de cartón resistente.",
      "649fhwpa2xs0": "Rellena los huecos con material protector para evitar daños.",
      "649fhwpa3fk0": "Asegúrate de imprimir la etiqueta de envío de manera clara y pegar bien, evitando que se desprenda durante el transporte",
      "649fhwpa3v40": "Por favor, envíe el móvil antiguo lo antes posible después de embalarlo. Si no se envía dentro del plazo establecido (10 días), el pedido será cancelado",
      "649fhwpa42s0": "Localizar puntos de entrega",
      "649fhwpa4as0": "Descargar etiqueta de envío",
      "649fhwpa4jo0": "Enviar",
      "649fhwpa4ok0": "Inicio",
      "649fhwpa4to0": "Envío exitoso",
      "649fhwpa4yk0": "¡Felicidad, descargado con éxito!"
    }
  },
  "component": {
    "tradeInProcess": {
      // "649f8aefats0": "Tiempo Agotado",
      "649f8aefats0": "El pedido ha expirado (más de 10 días)",
      // "649f8aefc1c0": "Reciclaje fallido",
      "649f8aefc1c0": "Reciclaje fallido",
      "649f8aefc9c0": "Vender ahora",
      "TradeIn": "Proceso de Trade-in",
      "logistic": 'Descargar etiqueta de envío',
      "start": "Pedido Creado",
      "success": "Su pedido ha sido realizado con éxito en nuestro sitio web.",
      "qc": "Inspección",
      "business": "Vamos a completar el proceso de inspección en 1-2 días laborales",
      "completed": "Completado",
      "successfully": "Tu trade-in proceso ha realizado con éxito",
      "orderInfor": "Información de pedido",
      "orderID": "Número de orden de reciclaje",
      "orderNum": "New device order number",
      "createTime": "Fecha de creación",
      "brand": "Marca seleccionada",
      "model": "Modelo seleccionada",
      "price": "Valor del dispositivo",
      "bonus": "Bono",
      "total": "Precio total",
      "logisticInfo": "Información logística",
      "available": "No logistics information available",
      "logisticNum": "Logistics number",
      "failRey": "Lamentamos que tu participación en el proceso trade-in no haya sido completada con éxito. Si tienes un plan de reciclaje para otros productos electrónicos, puedes hacer clic en el botón para obtener una cotización rápida",
      "userRes": "El usuario ya ha rechazado la oferta",
      "successPrice": "The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.",
      "sure": "Aceptar",
      "Reject": "Rechazar",
      "congratulation": "Congratulations QC No difference.",
      "finPirce": "Precio final",
      "copySuccess": "Copiado exitosamente",
      "copyfail": "Copia fallida",
      "sureSuccess": "El proceso de selección de productos",
      "submitError": "Envío fallido",
      "detectionResult": "Resultado de la detección",
      "Collected": "Recogido",
      "inTransit": "En Transito",
      "656g0lj3sav6": "Procesos",
      "656g0lj3cd5a": "Complete correctamente su información personal y realice su pedido",
      "656g0lj3dr9a": "La inspección para su móvil será completado dentro de 48 horas a su llegado a nuestro centro",
      "656g0lj3epal": "Una vez completada la inspección, nos pondremos en contacto con usted con una oferta final por correo electrónico",
      "656g0lj3pda2": "Ha elegido",
      "656g0lj3ed3d": "Inspección",
      "656g0lj3esf3": "Copiar",
      "expertDiscount": "Código de promoción",  // 推广码补贴
      "invalidCode": "Código no disponible",
      "toastTip": "Marque para aceptar la Política de Privacidad y Términos.",
      '656g0lj3sf6e': 'Los bonos promocionales son ofrecidos y gestionados por las marcas asociadas. Se abonarán por separado y no forman parte de la valoración del dispositivo antiguo.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Negarse a reciclar",
      "64a9shqq3k00": "Confirmas tu negativa a reciclar",
      "64a9shqq3r00": "Cancelación exitosa",
      "64a9shqq3ws0": "Cancelación fallida",
      "sureCancel": "Confirmar cancelación"
    }
  },
  "blog": {
    "blogList": {
        "64wgr171lsk0": "Vistas",
        "64wgr171nq40": "No se encontró ningún registro",
        "64wgr171av65": "发布日期"
    },
    "blogDetail": {
        "64wgr9y5r7s0": "Vistas",
        "64wgr171wdx9": "Detalles",
    }
  },
  "cookieNotice": {
    "title": "Aviso sobre el uso de cookies",
    "description": "Utilizamos cookies para mejorar su experiencia de navegación. Al continuar utilizando este sitio web, usted acepta nuestra",
    "cookiePolicy": "Política de Cookies",
    "acceptAll": "Aceptar todas las cookies",
    "acceptNecessary": "Aceptar solo las cookies necesarias",
    "customize": {
      "title": "Seleccione los tipos de cookies que desea aceptar:",
      "necessary": {
        "label": "Cookies necesarias",
        "description": "Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden desactivar."
      },
      "analytics": {
        "label": "Cookies de análisis",
        "description": "Estas cookies nos ayudan a entender cómo interactúan los visitantes con nuestro sitio."
      },
      "marketing": {
        "label": "Cookies de marketing",
        "description": "Estas cookies rastrean la actividad del usuario en distintos sitios para mostrar publicidad relevante."
      }
    },
    "save": "Guardar configuración",
    "cancel": "Cancelar"
  }

}
